import {
  PRODUCTS_ASYNC_UPDATE_SUCCESS,
  PRODUCTS_RESET_STATE,
  SET_LOADING_PRODUCTS_STATUS,
  UPDATE_PRODUCT_PRICE,
  SET_PRODUCTS_RESET_KEY_STATUS,
} from 'actions/products';
import _ from 'lodash';

const initialState = {
  firstRecNum: 0,
  lastRecNum: 0,
  totalNumRecs: 0,
  products: [],
  loading: false,
  resetKey: 0,
};

const actionsMap = {
  [PRODUCTS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return action.data;
  },
  [UPDATE_PRODUCT_PRICE]: (state, action) => {
    const priceList = action.data;
    const stateProducts = state.products;
    _.forEach(priceList, productPrice => {
      const targetProduct = _.find(stateProducts, product => product.supc === productPrice.supc);
      targetProduct.unitCost = productPrice.unitCost;
      targetProduct.priceLoadSuccess = productPrice.priceLoadSuccess;
      targetProduct.priceLoaded = productPrice.priceLoaded;
    });
    return {
      ...state,
      products: _.cloneDeep(stateProducts),
    };
  },
  [PRODUCTS_RESET_STATE]: () => {
    return initialState;
  },
  [SET_LOADING_PRODUCTS_STATUS]: (state, action) => {
    return {
      ...state,
      loading: action.isLoading,
    };
  },
  [SET_PRODUCTS_RESET_KEY_STATUS]: (state, action) => {
    return {
      ...state,
      resetKey: action.resetKey,
    };
  },
};

export default function products(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
